import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import type { PropsWithChildren, ReactNode } from 'react';
import { useEffect, useState } from 'react';

import NamsanImg from '@/assets/images/members/namsan.png';
import RefreshIcon from '@/assets/images/refresh.svg';

import type { ITutorialStepComponent } from '..';

export interface TutorialLayoutProps extends ITutorialStepComponent {
	visibleAvatar?: boolean;
	title: ReactNode;
}

export default function TutorialLayout({ visibleAvatar, title, onChangeComponent, children }: PropsWithChildren<TutorialLayoutProps>) {
	const [mounted, setMounted] = useState<boolean>(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	return (
		<Grid
			container
			direction="column"
			gap={2}
			width="100%"
			padding={{ xs: '52px 24px', md: '80px 80px 140px 80px' }}
			sx={{
				opacity: mounted ? 1 : 0,
				transform: `translateX(${mounted ? 0 : 50}px)`,
				transition: 'transform 0.5s ease, opacity 0.3s ease',
				'& img': {
					width: { xs: 56, md: 72 },
					height: { xs: 56, md: 72 },
				},
			}}
		>
			{visibleAvatar && <Image src={NamsanImg} alt="namsan" priority />}
			{typeof title === 'string' ? (
				<Typography fontSize={{ xs: 26, md: 34 }} fontWeight={700} lineHeight={{ xs: 1.3, md: '44px' }} marginBottom={2}>
					{title}
				</Typography>
			) : (
				title
			)}
			{children}
			<Grid container>
				<Button
					variant="text"
					onClick={() => {
						onChangeComponent('prepare');
					}}
					sx={{
						margin: '9px 0 0 0',
						padding: 0,
						':hover': {
							bgcolor: 'transparent',
						},
					}}
				>
					<RefreshIcon width={20} height={20} />
					<Typography fontSize={16} color="grey.800" marginLeft="4px" sx={{ textDecoration: 'underline' }}>
						처음으로
					</Typography>
				</Button>
			</Grid>
		</Grid>
	);
}
